import { render } from "./DoctorLayout.vue?vue&type=template&id=da776c20&scoped=true"
import script from "./DoctorLayout.vue?vue&type=script&lang=js"
export * from "./DoctorLayout.vue?vue&type=script&lang=js"

import "./DoctorLayout.vue?vue&type=style&index=0&id=da776c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da776c20"]])

export default __exports__